import { Camera, PencilLine, SignOut, Star } from '@phosphor-icons/react';
import React, {useEffect, useRef, useState} from 'react';
import {logout} from '../../services/apis/global';
import {api} from '../../services/http';
import {urls} from '../../services/endPoint';
import {useAppDispatch, useAppSelector} from '../../services/redux/store';
import {SET_LOADING} from '../../services/redux/reducers/loadingSlice';
import {useNavigate} from 'react-router-dom';

export function ProfileCard() {
  const profile = useAppSelector((state) => state.userReducer.data);
  const [rating, setRating] = useState<{average: number | null; count: number} | null>(null);

  useEffect(() => {
    api(urls.workerRating, {method: 'GET'}, true).then((res) => {
      if (res?.code == 200) setRating(res.data);
    });
  }, []);
  return (
    <section className="infoBox">
      <h4>پروفایل</h4>
      <div className="profileCardContainer">
        <div className="profileCardDetails">
          <span className="iconInput">
            {profile.name || 'نام'}
            {/* <PencilLine */}
            {/*   onClick={() => { */}
            {/*     // setNameDisabled(false); */}
            {/*     navigate('/profile/edit') */}
            {/*   }} */}
            {/* /> */}
          </span>
          <span className="iconInput">
            {profile.lastName || 'نام خانوادگی'}
            {/* <PencilLine */}
            {/*   onClick={() => { */}
            {/*     // setLastNameDisabled(false); */}
            {/*     navigate('/profile/edit'); */}
            {/*   }} */}
            {/* /> */}
          </span>
          <span className="iconInput">
            <Star size={20} weight="fill" color="#f5b301" />
            {rating?.average != null
              ? `${rating.average.toLocaleString('fa-IR')} از ۵ (${rating.count.toLocaleString('fa-IR')} نظر)`
              : 'هنوز امتیازی ثبت نشده است'}
          </span>
          <span className="iconInput">
            {profile.nationalCode || 'کد ملی'}
            {/* <PencilLine */}
            {/*   onClick={() => { */}
            {/*     // setSocialIdDisabled(false); */}
            {/*     navigate('/profile/edit') */}
            {/*   }} */}
            {/* /> */}
          </span>
        </div>
        <div className="profileCardPicture">
          <span className="profilePicture">
          <img src={profile.profilePic?.url || '/img/girl.png'} />
        </span>
        </div>
      </div>
    </section>
  );
}
